/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cat_medium'
export default icon
